<template>
  <div :class="['usb-page']">
    <!-- <TopNavBar /> -->

    <!-- Product Page based on Route, either /usb/sample-7 or /usb/transport -->

    <!-- <router-view v-slot="{ Component, route }">
      <transition name="fade" mode="out-in">
        <keep-alive>
          <component :is="Component" />
        </keep-alive>
      </transition>
    </router-view> -->
    <div class="landing-nav__logo">
      <img src="/figures/usb-club-wordmark.svg" @click="goHome" />
    </div>

    <div class="landing-nav__socials">
      <a href="https://www.are.na/teal/usb-club" target="_blank"><img src="/figures/icons/arena-logo.svg" /></a>
      <a href="https://www.instagram.com/bringyourusb" target="_blank"><img src="/figures/icons/ig-logo.svg" /></a>
      <a href="https://x.com/usbclub" target="_blank"><img src="/figures/icons/twitter-logo.svg" /></a>
    </div>

    <div class="usb-header">
      <div class="usb-header-inner" ref="usbheader">
        <div class="select-usb">Select your USB</div>
        <img v-if="usb == 's7'" src="/figures/usb.png" class="usb-header-img usb-header-img__sample-7 header-hide-1" />
        <div v-else-if="usb == 'transport'" class="transport-header-video floater">
          <div class="transport-image-container header-hide-1">
            <!-- <img src="/figures/transport/Aerodynamic-4SPP-140Res_frames_161-300_hero2.png" class="usb-header-img usb-header-img__transport header-hide-1"/> -->
            <ImageSequencePlayer
              imagePattern="/figures/transport/heroB_compressed/Aerodynamic-4SPP-140Res_frames_161-300_hero-looper.{frame}.webp"
              :startFrame="161"
              :endFrame="300"
              :autoPlay="true"
              :frameRate="24"
              altText="Auto-playing image sequence"
            />
          </div>
        </div>

        <div v-if="usb == 's7'" class="usb-header-text-container">
          <h1 class="usb-h1 header-hide-1">Classic</h1>
          <h2 class="header-hide-2 h2-subtitle">Carry What Matters.</h2>
          <div class="cta-container header-hide-3">
            <span class="detail-text detail-left">128 GB</span>
            <a href="https://buy.usb.club/products/classic" class="button cta-button"><span>Buy</span> $40 →</a>
            <span class="detail-text detail-right">Club Key</span>
          </div>
        </div>
        <div v-else-if="usb == 'transport'" class="usb-header-text-container usb-header-text-container__transport">
          <img src="/figures/transport-logotype.png" class="transport-logo header-hide-1" />
          <h2 class="header-hide-2 h2-subtitle">The drive you've been looking for.</h2>
          <div class="cta-container header-hide-3">
            <span class="detail-text detail-left">1 TB Drive</span>
            <a href="https://buy.usb.club/products/transport" class="button cta-button"><span>Buy</span> $180 →</a>
            <span class="detail-text detail-right">Club Key</span>
          </div>
        </div>
      </div>
    </div>
    <div @click="switchUSB" class="hero-left-arrow" >
      <img src="/figures/hero-left-arrow.svg"/>
    </div>
    <div @click="switchUSB" class="hero-right-arrow">
      <img src="/figures/hero-right-arrow.svg"/>
    </div>

    <a v-if="usb == 's7'" href="https://buy.usb.club/products/classic" class="button cta-button fixed-button-pre" ref="ctabutton"><span>Buy</span> →</a>
    <a v-else-if="usb == 'transport'" href="https://buy.usb.club/products/transport" class="button cta-button fixed-button-pre" ref="ctabutton"><span>Buy</span> →</a>

    <!-- <transition name="fade" mode="out-in"> -->
      <component :is="childComponent" :key="'component-' + this.usb"></component>
    <!-- </transition> -->
    <FooterBottom></FooterBottom>

    <!-- 
    Three approaches: 
    • Build both product pages into the same component. Would wind up with messy code, would be annoying to dig through to change any components if there's else-if everywhere. 
    • Build a base product page and have two child components it switches between. 
    • Build a base product page, that has the header in it, and then transitions out the children content. <<< This seems best.

    Risks:
    • How to know when to load each header type first, should check first onMount.
    • Setting different <head> details, can try using an if statement on url? Title needs to change if page changes though. 
    -->

  </div>
</template>

<script>
import USB_Transport from '../USB_Transport.vue';
import USB_Sample from '../USB_Sample.vue';
import FooterBottom from "../FooterBottom.vue";
import ImageSequencePlayer from "../ImageSequencePlayer.vue";

export default {
  name: "USBs",
  components: {
    USB_Transport,
    USB_Sample,
    FooterBottom,
    ImageSequencePlayer
  },
  data() {
    return {
    };
  },
  computed: {
    childComponent() {
      console.log('route: ', this.$route.path)

      if (this.$route.path === '/sample-7' || this.$route.path === '/classic') {
        return USB_Sample;
      } else {
        return USB_Transport;
      }
    },
    usb() {
      if (this.$route.path === '/sample-7' || this.$route.path === '/classic') {
        return 's7';
      } else {
        return 'transport';
      }
    }
  },
  created() {
  },
  mounted() {
    this.showHeader();

    window.onscroll = () => {
      var limit = Math.max(document.body.scrollHeight, document.body.offsetHeight,
        document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
      var limitTest = limit - 2*window.innerHeight;
      if(this.usb == 'transport'){
        limitTest = limit - 5*window.innerHeight;
      }
      if (window.scrollY > window.innerHeight && window.scrollY < limitTest) {
          this.$refs.ctabutton.classList.add('fixed-button');
      } else {
        this.$refs.ctabutton.classList.remove('fixed-button');
      }
    }

  },
  methods: {
    switchUSB() {
      if (this.usb == 's7') {
        this.transitionTo('/transport');
      } else {
        this.transitionTo('/classic');
      }
    },
    transitionTo(path){
      this.$refs.usbheader.classList.add('header-leave');
      setTimeout(() => {
        this.resetHeader();
        // window.location.href = path
        this.$router.push(path);
        this.showHeader();
      }, 400)
    },
    goHome() {
      this.transitionTo('/');
    },
    resetHeader() {
      this.$refs.usbheader.classList.remove('header-leave');
      this.$refs.usbheader.classList.remove('header-show');
    },
    showHeader() {
      setTimeout(() => {
        this.$refs.usbheader.classList.add('header-show');
      }, 15)
    }
  },
  // head() {
  //   return {
  //     title: "Buy an Official USB",
  //     meta: [
  //       {
  //         tagDuplicateStrategy: "replace",
  //         name: "twitter:title",
  //         content: "Join Waitlist",
  //       },
  //       {
  //         tagDuplicateStrategy: "replace",
  //         name: "twitter:description",
  //         content: "Network currently in Alpha.",
  //       },
  //       {
  //         name: "description",
  //         content: "Network currently in Alpha.",
  //       },
  //       {
  //         tagDuplicateStrategy: "replace",
  //         name: "og:description",
  //         content: "Network currently in Alpha.",
  //       },
  //       {
  //         tagDuplicateStrategy: "replace",
  //         name: "og:title",
  //         content: "Join Waitlist",
  //       },
  //     ],
  //   };
  // },
};
</script>

<style>

.mobile-show {
  display: none;
}

@media screen and (max-width: 700px) {
  .mobile-show {
    display: initial;
  }

  .feature-title-padded {
    font-size: 18px;
  }
}

.header-hide-1,
.header-hide-2,
.header-hide-3 {
  opacity: 0;
  transition: all 400ms ease-in-out;
  transform: translateY(-8px);
  filter: blur(3px);
}

.usb-header-img__transport {
  transition: all 400ms cubic-bezier(0.41, 0.02, 0.08, 1.18);
}

.transport-image-container {
  transition: all 400ms cubic-bezier(0.41, 0.02, 0.08, 1.18);
  position: relative; 
  width: auto; 
}

.usb-header-img__sample-7.header-hide-1 {
  transform: scale(0.75);
}

.header-show.header-leave .usb-header-img__sample-7.header-hide-1 {
  transform: scale(0.75);
  filter: blur(3px);
}

.transport-image-container.header-hide-1,
.usb-header-img__transport.header-hide-1 {
  opacity: 0;
  transform: translate(50vw, 0) rotate(8deg);
  filter: blur(3px);
}

.header-show.header-leave .transport-image-container.header-hide-1,
.header-show.header-leave .usb-header-img__transport.header-hide-1 {
  opacity: 0;
  transform: translate(-50vw, 0) rotate(4deg);
  filter: blur(3px);
}

.header-show.header-leave .header-hide-1 {

}

.header-show .usb-header-img__transport.header-hide-1 {
  
}

.header-show .header-hide-1 {
  opacity: 1;
  transition-delay: 0ms;
  transform: translateY(0) rotate(0deg) scale(1);
  filter: blur(0px);
}

.header-show .header-hide-2 {
  opacity: 1;
  transition-delay: 150ms;
  transform: translateY(0);
  filter: blur(0px);
}

.header-show .header-hide-3 {
  opacity: 1;
  transition-delay: 200ms;
  transform: translateY(0);
  filter: blur(0px);
}

.header-show.header-leave .header-hide-1 {
  opacity: 0;
  transition-delay: 150ms;
  transform: translateY(8px);
  filter: blur(3px);
}

.header-show.header-leave .header-hide-2 {
  opacity: 0;
  transition-delay: 100ms;
  transform: translateY(8px);
  filter: blur(3px);
}

.header-show.header-leave.header-show .header-hide-3 {
  opacity: 0;
  transition-delay: 0ms;
  transform: translateY(8px);
  filter: blur(3px);
}

.landing-nav__logo {
  margin-left: 3.2rem;
  margin-top: 2.4rem;
  align-self: flex-start;
  z-index: 100;
}

.landing-nav__logo img {
  height: 2.4rem;
  width: auto;
}

.landing-nav__socials {
  position: absolute;
  top: 2.4rem;
  right: 2.4rem;
  display: flex;
  flex-direction: row;
  grid-gap: 1.6rem;
  z-index: 100;
}

.landing-nav__socials img {
  height: 2rem;
  width: auto;
  transition: all 200ms ease-in-out;
  opacity: 0.7;
}

.landing-nav__socials img:hover {
  cursor: pointer;
  opacity: 1;
}

@media screen and (max-width: 700px) {

  .landing-nav__socials {
    top: 2.4rem;
    right: 2.4rem;
  }

  .landing-nav__socials img {
    height: 1.6rem;
  }
}

.hero-right-arrow {
  position: absolute;
  right: 0;
  height: 100vh;
  padding-top: 33vh;
  padding-right: 3.2rem;
  padding-left: 1rem;
  top: 0;
  cursor: pointer;
  width: 4vw;
  opacity: 1;
  transition: all 150ms cubic-bezier(0.56, 0.22, 0, 0.94);

  background-image: linear-gradient(to left, rgba(28,28,28,1), rgba(28,28,28,0));
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 10;
}

.hero-right-arrow img {
  transition: all 150ms cubic-bezier(0.56, 0.22, 0, 0.94);
  transform-origin: center center;
}

.hero-right-arrow:hover {
  /* opacity: 0.85; */
}

.hero-right-arrow:hover img {
  /* transform: scale(0.9); */
  transform: translateX(0.6rem);
}

.hero-right-arrow:active img {
  transform: translateX(1rem);
}

.hero-left-arrow {
  position: absolute;
  left: 0;
  height: 100vh;
  padding-top: 33vh;
  padding-left: 3.2rem;
  padding-right: 1rem;
  top: 0;
  cursor: pointer;
  width: 4vw;
  opacity: 1;
  transition: all 150ms cubic-bezier(0.56, 0.22, 0, 0.94);

  background-image: linear-gradient(to right, rgba(28,28,28,1), rgba(28,28,28,0));
  background-repeat: no-repeat;
  background-size: cover;

  z-index: 10;
}

.hero-left-arrow img {
  transition: all 150ms cubic-bezier(0.56, 0.22, 0, 0.94);
  transform-origin: center center;
}

.hero-left-arrow:hover {
  /* opacity: 0.85; */
}

.hero-left-arrow:hover img {
  /* transform: scale(0.9); */
  transform: translateX(-0.8rem);
}

.hero-left-arrow:active img {
  transform: translateX(-1rem);
}

.select-usb {
  position: absolute;
  top: 2.2rem;
  background: none;
  font-family: 'Untitled Sans', sans-serif;
  color: #8E8E8E;
  font-size: 20px;
  font-weight: 500;
  border: none;
  cursor: pointer;
}

h1.usb-h1 {
  font-size: 87px;
}

h3 {
  font-family: 'ISO', monospace;
  font-size: 20px;
  letter-spacing: normal;
  font-weight: 600;
  color: #F9F9F9;
}

h2.h2-subtitle {
  font-family: 'Untitled Serif', serif;
  font-size: 38px;
  letter-spacing: -1px;
  font-weight: 400;
  margin-bottom: 2rem;
}

.detail-text {
  font-family: 'ISO', monospace;
  font-size: 16px;
  white-space: nowrap;
  width: 30vw;
}

.detail-left {
  text-align: right;
}

.detail-right {
  text-align: left;
}

.cta-container {
  display: flex;
  gap: 1.5rem;
  align-items: center;
  justify-content: center;
  max-width: 100vw;
}

.cta-button {
  border-radius: 9999px;
  width: auto;
  transition: top 0.5s;
  white-space: nowrap;
}

a.cta-button {
  text-decoration: none;
}


.usb-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  position: relative;
}

.usb-section {
  /* height: 100vh; */
  width: 100%;
}

.usb-header {
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4rem;
}

.usb-header-inner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4rem;
}

.usb-header-text-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  z-index: 100;
  max-width: 100%;
}

.usb-header-img {
  width: 20vw;
  max-width: 300px;
  object-position: center;
  object-fit: contain;
  padding-bottom: 6rem;
}

.usb-header-img__transport {
  width: 100%;
  max-width: 100%;
  margin-top: -18rem;
}

.transport-header-video {
  height: 20vh;
  width: 70vh;
  max-width: 100vh;
}

/* .transport-header-video-between {
  position: relative;
  width: 100%;
} */

.transport-header-video .image-sequence-player {
  margin-top: -18rem;
}

.transport-logo {
  padding: 8rem 8rem 4rem 8rem;
  width: 100vw;
  max-width: 1200px;
  box-sizing: border-box;
}

.fixed-button-pre {
  position: fixed;
  top: -6rem;
  z-index: 1000;
  filter: unset;
}

.fixed-button {
  position: fixed;
  top: 2rem;
  filter: unset;
}

@media screen and (max-width: 700px) {
  .landing-nav__logo {
    margin-left: 2.4rem;
    margin-top: 2.4rem;
  }

  .landing-nav__logo img {
    height: 2rem;
  }

  .select-usb {
    font-size: 16px;
    position: relative;
    top: unset;
    display: none;
  }

  .hero-left-arrow {
    padding-top: 28.5rem;
    height: 10vh;
    padding-left: 1.5rem;
  }
  .hero-right-arrow {
    padding-top: 28.5rem;
    height: 10vh;
    padding-right: 1.5rem;
  }

  .usb-header {
    height: unset;
    margin-top: 16vh;
  }

  .usb-header-img {
    padding-top: 1rem;
    width: 46vw;
    padding-bottom: 4rem;
  }

  h1.usb-h1 {
    font-size: 48px;
  }

  .usb-header-text-container__transport h2 {
    font-size: 27px;
  }

  .transport-logo {
    padding: 8rem 2.5rem 2.25rem 2.5rem;
  }

  .transport-header-video {
    width: 48vh;
    /* max-width: 100vw; */
  }

  .transport-header-video .image-sequence-player {
    margin-top: -6rem;
  }
}

.floater {
  animation: float 5s ease-in-out infinite;
}

@keyframes float {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }

  100% {
    transform: translateY(0);
  }
}

.bottom-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: 2.4rem;
  padding-bottom: 2.4rem;
  transform: scale(0.8);
}
</style>
